module.exports = __webpack_public_path__ + "static/img/cash-envelope.2f5cbcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-sign-in/cash-envelope.png
// module id = amrF
// module chunks = 216